import Welcome from "./components/Welcome";
import Features from "./components/Features";
import Others from "./components/Others";
import GetInTouch from "../home/components/GetInTouch";
import SEO from "../../components/common/SEO";
    
const index = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "Youstad Bite",
    "description": "Comprehensive canteen management system for academies. Manage food services, track inventory, and optimize cafeteria operations.",
    "url": "https://youstad.com/bite",
    "applicationCategory": "BusinessApplication",
    "operatingSystem": "Web",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "featureList": [
      "Canteen Management",
      "Food Service Tracking",
      "Inventory Management",
      "Cafeteria Operations"
    ]
  };

  return (
    <>
      <SEO
        title="Youstad Bite - Canteen Management System | Academy Food Service Management"
        description="Comprehensive canteen management system for academies. Manage food services, track inventory, and optimize cafeteria operations with Youstad Bite."
        keywords="canteen management, food service management, cafeteria system, academy canteen, food inventory, cafeteria operations, school canteen"
        url="https://youstad.com/bite"
        structuredData={structuredData}
      />
      <Welcome />
      <Features />
      <Others />
      <GetInTouch />
    </>
  );
};

export default index;